module.exports = __webpack_public_path__ + "img/tjx-clause-bg@2x.1280623f.png";